/* eslint-disable semi */
/* eslint-disable comma-dangle */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../configs/apiConfig";
export const fetchAds = createAsyncThunk(
  "adds/fetchAds",
  async (type , { rejectWithValue }) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      const response = await axios.get(`${API_URL}/admin/ad?type=${type}`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addsSlice = createSlice({
  name: "adds",
  initialState: {
    loading: false,
    error: null,
    success: false,
    ads: null,
  },
  reducers: {
    resetAddsState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.ads = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAds.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(fetchAds.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.ads = action.payload;
      })
      .addCase(fetchAds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetAddsState } = addsSlice.actions;
export default addsSlice.reducer;
